// Article.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const Article = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Article data
  const articles = [
    {
      id: 1,
      title: "Decoding Your Cat's Body Language",
      content: (
        <div>
          <h1>Decoding Your Cat's Body Language</h1>
          <p>
            Cats are known for their independent and sometimes mysterious behavior, which can make understanding their emotions a bit tricky. However, by learning to recognize and interpret their body language, you can gain valuable insight into what your cat is feeling and strengthen the bond you share. Here’s a guide to decoding some common cat body language cues.
          </p>
          <h2>1. Tail Talk</h2>
          <p>
            The position and movement of your cat's tail can reveal a lot about their mood:
          </p>
          <ul>
            <li><strong>Tail Upright and Quivering:</strong> A cat with a raised, slightly vibrating tail is often showing excitement or greeting someone they like.</li>
            <li><strong>Tail Flicking or Thumping:</strong> Rapid tail movements can indicate irritation or frustration. It’s a sign that your cat may need some space.</li>
            <li><strong>Puffed-Up Tail:</strong> A puffed-up tail is a classic sign of fear or feeling threatened. Your cat is trying to make themselves appear larger to ward off potential threats.</li>
          </ul>
          <h2>2. Ears and Eyes</h2>
          <p>
            A cat's ears and eyes are key indicators of their emotional state:
          </p>
          <ul>
            <li><strong>Forward-Facing Ears:</strong> When a cat’s ears are pointing forward, they’re likely feeling curious or engaged.</li>
            <li><strong>Flattened Ears:</strong> Ears pulled back or flat against the head indicate fear, anger, or stress. This is often a defensive posture.</li>
            <li><strong>Slow Blinking:</strong> Slow blinks are a cat’s way of expressing trust and affection. You can even try slowly blinking back as a way to communicate warmth.</li>
          </ul>
          <h2>3. Body Posture and Movement</h2>
          <p>
            A cat’s overall posture provides additional context for understanding how they feel:
          </p>
          <ul>
            <li><strong>Arched Back with Fur Standing Up:</strong> If your cat arches their back with puffed fur, they’re frightened or trying to intimidate. This reaction is often accompanied by a defensive hiss.</li>
            <li><strong>Lying on Their Side or Back:</strong> Cats who roll onto their side or back and expose their belly are showing vulnerability. This is often a sign of trust, though it doesn’t always mean they want a belly rub.</li>
          </ul>
          <h2>4. Vocalizations</h2>
          <p>
            In addition to body language, vocal cues like purring, hissing, or chirping play a role in communication:
          </p>
          <ul>
            <li><strong>Purring:</strong> A cat that purrs is generally content or happy, though it can also be a way for them to self-soothe if they’re in pain.</li>
            <li><strong>Hissing or Growling:</strong> These sounds indicate that your cat feels threatened or is upset and wants to be left alone.</li>
          </ul>
          <h2>Conclusion</h2>
          <p>
            By paying close attention to these body language cues, you can better understand your cat's needs and emotions. Each cat has unique quirks, so getting to know your own pet’s specific signals can help you build a stronger, more empathetic relationship. Remember, a respectful approach to your cat’s boundaries and communication will help them feel safe and loved in their environment.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      title: "Guide to Vaccinations for Dogs and Cats",
      content: (
        <div>
          <h1>Guide to Vaccinations for Dogs and Cats</h1>
          <p>
            Vaccinations are an essential part of ensuring your dog or cat remains healthy and protected from various preventable diseases. Regular vaccination schedules help safeguard your pets, allowing them to live longer, healthier lives. This guide will walk you through the vaccinations your pets need and why they are so important.
          </p>

          <h2>Why Vaccinate?</h2>
          <p>
            Vaccinations help to protect pets from infectious diseases that can lead to severe illness or even death. By vaccinating your pets, you prevent them from contracting and spreading diseases to other animals and humans. It's crucial for both the health of your pet and the overall safety of the community.
          </p>

          <h2>Core Vaccinations for Dogs</h2>
          <p>
            Dogs need several core vaccines to protect them from the most serious and common diseases:
          </p>
          <ul>
            <li><strong>Rabies:</strong> Required by law in many areas, rabies is a fatal disease that affects the brain and spinal cord. It can spread to humans and other animals.</li>
            <li><strong>Distemper:</strong> A highly contagious viral disease that can cause respiratory and gastrointestinal problems, along with neurological issues.</li>
            <li><strong>Parvovirus:</strong> A virus that causes severe gastrointestinal distress and can be fatal if not treated promptly.</li>
            <li><strong>Leptospirosis:</strong> A bacterial infection that can cause kidney and liver damage, spread through contaminated water or urine.</li>
          </ul>

          <h2>Core Vaccinations for Cats</h2>
          <p>
            Similar to dogs, cats also need core vaccinations to protect them from dangerous diseases:
          </p>
          <ul>
            <li><strong>Rabies:</strong> Just as with dogs, rabies is a fatal disease that can also affect cats and spread to humans.</li>
            <li><strong>Feline Distemper (Panleukopenia):</strong> A viral disease that causes severe gastrointestinal distress and can be fatal.</li>
            <li><strong>Feline Herpesvirus and Calicivirus:</strong> Two viruses that cause upper respiratory infections, leading to sneezing, coughing, and eye discharge.</li>
          </ul>

          <h2>Optional Vaccines</h2>
          <p>
            In addition to the core vaccines, there are optional vaccines that may be recommended based on your pet's lifestyle and the risks in your area. These vaccines include:
          </p>
          <ul>
            <li><strong>Canine Influenza:</strong> A flu virus affecting dogs, particularly in high-density environments like shelters or dog parks.</li>
            <li><strong>Bordetella (Kennel Cough):</strong> A vaccine for dogs that frequent boarding facilities, dog parks, or grooming areas.</li>
            <li><strong>Feline Leukemia (FeLV):</strong> An optional vaccine for cats that are outdoor or at higher risk of exposure to infected cats.</li>
          </ul>

          <h2>Affordable Mobile Care for Vaccinations</h2>
          <p>
            At the Nairobi Animal Wellness Center, we understand that getting your pet to a clinic can sometimes be a hassle. That’s why we offer affordable mobile care services, bringing essential veterinary services like vaccinations directly to your doorstep. Whether you're at home, at work, or anywhere in Nairobi, we make it easier and more convenient for you to get your pets vaccinated and keep them healthy. Our experienced mobile team ensures a safe, stress-free experience for both you and your furry companions.
          </p>

          <h2>Conclusion</h2>
          <p>
            Regular vaccinations are a vital part of maintaining your pet's health. By keeping up with the recommended vaccination schedule, you can help protect your pet from preventable diseases and ensure they live a long, healthy life. At Nairobi Animal Wellness Center, we make it easy and affordable for you to care for your pet’s health through our mobile veterinary services. Contact us today to schedule a vaccination appointment!
          </p>
        </div>
      ),
    },
    {
      id: 3,
      title: "Tips for Safe and Stress-Free Adventures",
      content: (
        <div>
          <h1>Tips for Safe and Stress-Free Adventures</h1>
          <p>
            Taking your dog on an adventure can be an exciting and fulfilling experience for both you and your furry friend. Whether it's a road trip, a hike, or a visit to the park, proper preparation ensures the trip is safe, enjoyable, and stress-free. Here are some practical tips to make your next outing with your dog a success.
          </p>

          <h2>1. Plan Ahead</h2>
          <p>
            Before heading out, make sure your destination is dog-friendly and suitable for your pet's needs. Check for pet policies at parks, beaches, or accommodations. Always carry an updated ID tag and ensure your dog's vaccinations are current.
          </p>

          <h2>2. Pack Essentials</h2>
          <p>
            Assemble a travel kit that includes:
          </p>
          <ul>
            <li>Leash, harness, and collar</li>
            <li>Water and a collapsible bowl</li>
            <li>Pet waste bags</li>
            <li>Favorite toys or a blanket for comfort</li>
            <li>Pet-specific first-aid supplies</li>
          </ul>

          <h2>3. Safety in Transit</h2>
          <p>
            Whether you're driving or flying, prioritize your dog's safety:
          </p>
          <ul>
            <li><strong>Car Safety:</strong> Use a crash-tested dog harness, a pet seatbelt, or a crate to keep your dog secure in the car. Never let your dog roam freely in a moving vehicle.</li>
            <li><strong>Air Travel:</strong> If flying, check airline pet policies and ensure your dog is comfortable in an airline-approved carrier.</li>
          </ul>

          <h2>4. Keep Your Dog Comfortable</h2>
          <p>
            Long trips can be tiring for your dog. Take frequent breaks for bathroom stops, stretching, and hydration. Stick to your dog's regular feeding schedule to avoid upset stomachs.
          </p>

          <h2>5. Monitor for Signs of Stress</h2>
          <p>
            Watch for signs of stress, such as panting, pacing, or whining. Provide reassurance and adjust your plans if your dog seems overwhelmed.
          </p>

          <h2>6. Consider Mobile Services</h2>
          <p>
            If your dog requires last-minute check-ups or additional vaccinations before your adventure, the Nairobi Animal Wellness Center offers convenient mobile veterinary services. Our team comes to your home to ensure your pet is in perfect health before you hit the road. With affordable and personalized care, we make it easy to prepare for stress-free travel.
          </p>

          <h2>7. Post-Adventure Care</h2>
          <p>
            After your trip, check your dog for ticks, cuts, or other injuries. Schedule a follow-up with your vet if needed to ensure your dog remains healthy and happy after the adventure.
          </p>

          <h2>Conclusion</h2>
          <p>
            Traveling with your dog can be a rewarding experience with the right preparation and care. By following these tips and utilizing services like those offered by the Nairobi Animal Wellness Center, you can ensure every outing is safe, enjoyable, and stress-free for both you and your canine companion. Start planning your next adventure today!
          </p>
        </div>
      ),
    }, 
    {
      id: 4,
      title: "Common Signs Your Pet Needs to See a Vet",
      content: (
        <div>
          <h1>Common Signs Your Pet Needs to See a Vet</h1>
          <p>
            Pets, like humans, can face health challenges, and recognizing the warning signs early can make a significant difference in their well-being. As a pet parent, it's essential to know when your furry friend needs professional attention. Here are some common indicators that your pet may need to see a vet.
          </p>

          <h2>1. Changes in Eating or Drinking Habits</h2>
          <p>
            A sudden loss of appetite or excessive thirst can signal an underlying health issue. Conditions like kidney disease, diabetes, or dental problems are often accompanied by these symptoms.
          </p>

          <h2>2. Unexplained Weight Loss or Gain</h2>
          <p>
            If your pet is losing or gaining weight without a change in diet or activity level, it could be a sign of metabolic issues, hormonal imbalances, or other health concerns that require veterinary evaluation.
          </p>

          <h2>3. Lethargy or Unusual Behavior</h2>
          <p>
            If your pet seems unusually tired, disinterested in play, or is hiding more than usual, it might be a sign of pain, illness, or emotional distress. Behavioral changes should never be ignored.
          </p>

          <h2>4. Vomiting or Diarrhea</h2>
          <p>
            Occasional vomiting or diarrhea is usually not a cause for alarm, but if it persists for more than 24 hours, is accompanied by blood, or your pet shows other symptoms like lethargy, seek veterinary care immediately.
          </p>

          <h2>5. Persistent Scratching or Licking</h2>
          <p>
            Excessive scratching, licking, or biting could indicate skin allergies, infections, or parasites. Left untreated, these issues can lead to discomfort and complications.
          </p>

          <h2>6. Breathing Difficulties</h2>
          <p>
            If your pet is wheezing, coughing, or having difficulty breathing, it’s crucial to seek immediate medical attention. These symptoms can indicate respiratory infections, asthma, or heart problems.
          </p>

          <h2>7. Visible Signs of Pain</h2>
          <p>
            Limping, whimpering, or sensitivity to touch may indicate an injury or condition causing discomfort. Pets often hide their pain, so these signs should be taken seriously.
          </p>

          <h2>8. When in Doubt, Call the Vet</h2>
          <p>
            If you’re ever unsure about your pet’s health, it’s always better to err on the side of caution and consult a professional. Regular check-ups and preventive care can go a long way in keeping your pet healthy.
          </p>

          <h2>Nairobi Animal Wellness Center – Here for You and Your Pet</h2>
          <p>
            At the Nairobi Animal Wellness Center, we understand that getting your pet to a vet isn’t always easy. That’s why we offer affordable mobile veterinary care right at your doorstep. From routine check-ups to addressing sudden health concerns, our compassionate team ensures your pet gets the care they deserve in the comfort of their familiar environment. Don’t wait—let us help you keep your furry friend healthy and happy.
          </p>

          <h2>Conclusion</h2>
          <p>
            Recognizing the signs that your pet needs to see a vet is essential for their long-term health and happiness. By staying vigilant and seeking professional care when needed, you can ensure your pet enjoys a vibrant and fulfilling life. Trust the Nairobi Animal Wellness Center to support you every step of the way.
          </p>
        </div>
      ),
    },
    {
      id: 5,
      title: "Pet Nutrition 101: What Should Your Pet Eat?",
      content: (
        <div>
          <h1>Pet Nutrition 101: What Should Your Pet Eat?</h1>
          <p>
            Providing your pet with proper nutrition is one of the most important ways to ensure their health and happiness. However, understanding what constitutes a balanced diet for your furry friend can sometimes feel overwhelming. Here’s a guide to help you make the best choices for your pet’s dietary needs.
          </p>

          <h2>1. Understanding Your Pet’s Dietary Needs</h2>
          <p>
            Dogs and cats have different nutritional requirements, and even within species, factors like age, breed, activity level, and health status play a role in determining their diet. Always choose food specifically formulated for your pet’s species and life stage.
          </p>

          <h2>2. Key Nutritional Components</h2>
          <p>
            A balanced pet diet includes the following components:
          </p>
          <ul>
            <li><strong>Proteins:</strong> Essential for growth and maintenance of healthy muscles and tissues. Look for high-quality animal proteins like chicken, fish, or lamb.</li>
            <li><strong>Fats:</strong> Provide energy and help maintain a healthy coat and skin. Omega-3 and Omega-6 fatty acids are particularly beneficial.</li>
            <li><strong>Carbohydrates:</strong> Offer a source of energy, though cats require fewer carbs than dogs. Ensure carbs come from whole grains or vegetables.</li>
            <li><strong>Vitamins and Minerals:</strong> Support overall health, from immune function to bone strength. Complete and balanced commercial pet foods typically meet these needs.</li>
          </ul>

          <h2>3. Avoiding Harmful Foods</h2>
          <p>
            Some human foods are toxic to pets. Avoid feeding your pets items like chocolate, grapes, raisins, onions, garlic, and anything containing xylitol. When in doubt, consult a veterinarian.
          </p>

          <h2>4. The Role of Treats</h2>
          <p>
            Treats can be a great way to bond with your pet and reinforce good behavior, but they should not exceed 10% of their daily calorie intake. Opt for healthy, natural treats whenever possible.
          </p>

          <h2>Nairobi Animal Wellness Center – Your Partner in Pet Nutrition</h2>
          <p>
            At the Nairobi Animal Wellness Center, we know that every pet is unique. That’s why we offer personalized guidance on pet nutrition as part of our affordable mobile veterinary services. Whether you’re dealing with a picky eater or managing a special dietary requirement, our team is here to help. Let us assist you in crafting a meal plan that ensures your pet gets the nutrients they need to thrive.
          </p>

          <h2>5. Transitioning to a New Diet</h2>
          <p>
            If you need to change your pet’s diet, do so gradually to avoid digestive upset. Mix small amounts of the new food with their current food, increasing the proportion over 7–10 days until the transition is complete.
          </p>

          <h2>Conclusion</h2>
          <p>
            Good nutrition is the cornerstone of your pet’s health. By providing a balanced diet tailored to their needs, you can help them live a long and happy life. For expert advice and convenient mobile care, trust the Nairobi Animal Wellness Center to support you in making the best choices for your furry friend.
          </p>
        </div>
      ),
    },
    {
      id: 6,
      title: "How to Choose the Right Pet for Your Lifestyle!",
      content: (
        <div>
          <h1>How to Choose the Right Pet for Your Lifestyle!</h1>
          <p>
            Choosing the right pet is a big decision that requires careful thought and planning. Pets are lifelong companions, and finding one that suits your lifestyle will lead to a happier life for both you and your furry friend. Here's a guide to help you make an informed choice.
          </p>

          <h2>1. Assess Your Lifestyle</h2>
          <p>
            Consider your daily routine, activity level, and living space. For instance:
          </p>
          <ul>
            <li><strong>Busy Professionals:</strong> Low-maintenance pets like cats or small rodents may be a better fit.</li>
            <li><strong>Active Individuals:</strong> Dogs with high energy levels, such as retrievers or border collies, could be ideal companions for outdoor adventures.</li>
            <li><strong>Families with Kids:</strong> Look for pets known for their gentle and friendly nature, such as Labradors or rabbits.</li>
          </ul>

          <h2>2. Research Pet Needs</h2>
          <p>
            Different pets have varying requirements for care, space, and attention. Make sure you understand the commitment involved in owning a specific type or breed of animal.
          </p>

          <h2>3. Consider Your Living Environment</h2>
          <p>
            The size of your home and access to outdoor space are key factors:
          </p>
          <ul>
            <li><strong>Apartment Dwellers:</strong> Small pets like cats, fish, or small dogs may be more suitable.</li>
            <li><strong>Large Homes with Yards:</strong> Larger dog breeds or active pets can thrive in these environments.</li>
          </ul>

          <h2>4. Evaluate Your Budget</h2>
          <p>
            Owning a pet comes with financial responsibilities, including food, veterinary care, grooming, and supplies. Be honest about what you can afford before making your choice.
          </p>

          <h2>Nairobi Animal Wellness Center – Your Guide to Finding the Perfect Pet</h2>
          <p>
            Choosing a pet can feel overwhelming, but you don't have to do it alone. The Nairobi Animal Wellness Center offers expert guidance to help you find a pet that fits your lifestyle and preferences. Our affordable mobile services also ensure that you’re equipped with the knowledge and resources to care for your new companion. From initial consultations to ongoing care, we’re here to support you every step of the way.
          </p>

          <h2>5. Plan for Long-Term Care</h2>
          <p>
            Remember, pets are a long-term commitment. Consider their lifespan, potential health issues, and how your lifestyle may evolve over time.
          </p>

          <h2>Conclusion</h2>
          <p>
            The right pet will bring joy, companionship, and enrichment to your life. By assessing your lifestyle, understanding pet needs, and seeking guidance from resources like the Nairobi Animal Wellness Center, you can confidently choose a pet that’s perfect for you. With thoughtful planning, you’ll be ready to welcome your new furry friend into your home and heart.
          </p>
        </div>
      ),
    }, 
    // Additional articles can go here
  ];

  // Find the article by ID
  const article = articles.find((article) => article.id === parseInt(id));

  if (!article) {
    return <p>Article not found.</p>;
  }

  return (
    <div className="article-content">
      <h1>{article.title}</h1>
      {article.content}
      {/* Back Button */}
      <button 
        onClick={() => navigate(-1)} 
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "#007BFF",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Back to Articles
      </button>
    </div>
  );
};

export default Article;
